export const apiErrorEventTarget = document.body;
